module.exports = __webpack_public_path__ + "static/media/vusebg@3x.58fd0638.jpg";